import {
  BlockNoteSchema,
  createHeadingBlockSpec,
  defaultBlockSpecs,
  defaultInlineContentSpecs
} from '@blocknote/core'
import { createReactBlockSpec } from '@blocknote/react'
import { PricingWidget } from 'Cube/view/common/widgets/Pricing/PhasesWidget'
import { VariableInlineContent } from '../QuoteVariables'

const phasesBlock = createReactBlockSpec(
  {
    type: 'phases',
    propSchema: {},
    content: 'none'
  },
  {
    render: () => (
      <PricingWidget data-testid="quote.contentEditor.phaseBlock" />
    ),
    meta: { selectable: true }
  }
)

const {
  audio,
  checkListItem,
  codeBlock,
  file,
  quote,
  toggleListItem,
  video,
  ...blockSpecs
} = defaultBlockSpecs

const customHeading = createHeadingBlockSpec({
  levels: [1, 2, 3]
})

export const blocknoteSchema = BlockNoteSchema.create({
  blockSpecs: {
    ...blockSpecs,
    heading: customHeading,
    phases: phasesBlock()
  },
  inlineContentSpecs: {
    ...defaultInlineContentSpecs,
    variable: VariableInlineContent
  }
})
